/**
 * 404 page.
 *
 * Rendered for any unmatched path. Offers the two routes that matter — home and
 * the public retrieval page — so a mistyped link never dead-ends someone trying
 * to recover a contact.
 */

import { el, icon } from "../ui/dom.js";
import { pageHeader } from "../ui/patterns.js";

/** @type {import("../app/router.js").PageRenderer} */
export default function renderNotFound() {
  const frag = document.createDocumentFragment();
  frag.append(
    pageHeader("Page not found", "The page you were looking for doesn't exist or has moved."),
  );

  frag.append(
    el("div", { class: "kin-cta-row" }, [
      el("wa-button", { variant: "brand", href: "/", dataset: { link: "" } }, [
        icon("house"),
        "Go home",
      ]),
      el("wa-button", { appearance: "outlined", href: "/retrieve", dataset: { link: "" } }, [
        icon("key"),
        "Retrieve contacts",
      ]),
    ]),
  );
  return frag;
}
